<template>
  <div class="card shadow-lg rounded-3 py-3" style="border-radius:0; border:none">
    <div class="card-body p-1">
      <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700"><span
          style="color: #0092f7">Log</span> In</h1>

      <form @submit.prevent="login">
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <input type="email" class="form-control"
                     v-model="formData.email" id="floatingTextInput1" placeholder="Email"
                     required>
              <label for="floatingTextInput1">Email</label>
            </div>
          </div>
        </div>
        <div class="form-floating mb-3">
          <input :type="passwordFieldType" class="form-control"
                 v-model="formData.password" id="floatingPasswordInput"
                 placeholder="Password"
                 required>
          <label for="floatingPasswordInput">Password</label>
        </div>
        <label class="show-password-checkbox">
          <input type="checkbox" v-model="show_password">
          Show Password
        </label>
        <div class="text-center">
          <button :disabled="loading" type="submit" class="btn">
            Login
            <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </form>
    </div>
    <p style="margin: 0; padding: 0; cursor: pointer"><a class="link-opacity-100-hover mx-2" @click="reset">Forgot Password</a></p>
  </div>
</template>

<script>
export default {
  name: "LoginForm",
  computed: {
    passwordFieldType() {
      return this.show_password ? 'text' : 'password';
    },
  },
  data() {
    return {
      formData: {
        email: '',
        password: '',
      },
      loading: false,
      show_password: false,
    };
  },
  methods: {
    reset(){
      return Swal.fire({
        title: "Enter your email",
        icon: "info",
        input: "email",
        showCancelButton: true,
        confirmButtonText: "Reset Password",
        showLoaderOnConfirm: true,
        preConfirm: async (input) => {
          return this.$store.dispatch('userResetPassword', input)
              .then(() => {
                this.$router.push('/ResetView');
                responses.showSuccess('Reset Token has been sent to your Email')
              })
        },
        allowOutsideClick: () => !Swal.isLoading()
      })
    },
    resetForm(){
      this.formData.email = '';
      this.formData.password = '';
    },
    login() {
      this.loading = true;
      return this.$store.dispatch('login', this.formData)
          .then(() => {
            this.resetForm();
            this.$router.push({name: 'OtpView'})
          })
          .finally(() => this.loading = false);
    },
  },
};
</script>

<style scoped>
.btn, .btn:hover {
  background: linear-gradient(90deg, rgba(65, 105, 225, 1) 0%, rgba(30, 144, 255, 1) 100%);
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
  max-width: 95vw;
  margin-top: -3rem !important;
}

.show-password-checkbox {
  margin-bottom: 20px;
}
</style>
